<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    v-model="show"
    size="lg"
    hide-footer
  >
    <div v-if="payment">
      <div
        v-if="payment.status && payment.status.toLowerCase() === 'pending'"
        class="mb-3"
      >
        <b-button
          :disabled="requeryLoading"
          variant="warning"
          @click="requeryPayment"
        >
          <span v-if="requeryLoading"
            ><b-spinner small></b-spinner> Re-querying...</span
          >
          <span v-else>Re-query Transaction</span>
        </b-button>
        <div v-if="requeryMessage" class="mt-2">
          <b-alert :variant="requerySuccess ? 'success' : 'danger'" show>
            {{ requeryMessage }}
          </b-alert>
        </div>
      </div>
      <h5>Payment Details</h5>
      <ul class="list-group mb-3">
        <li class="list-group-item"><strong>Gateway:</strong> {{ payment.gateway || 'remita' }}</li>
        <li class="list-group-item"><strong>Reference:</strong> {{ payment.rrr || payment.gateway_ref }}</li>
        <li class="list-group-item">
          <strong>Name:</strong> {{ payment.name }}
        </li>
        <li class="list-group-item">
          <strong>Matric No:</strong> {{ payment.matric_number }}
        </li>
        <li class="list-group-item">
          <strong>Email:</strong> {{ payment.email }}
        </li>
        <li class="list-group-item">
          <strong>Programme:</strong> {{ payment.programme }}
        </li>
        <li class="list-group-item">
          <strong>Degree:</strong> {{ payment.degree }}
        </li>
        <li class="list-group-item">
          <strong>Type:</strong> {{ payment.type }}
        </li>
        <li class="list-group-item">
          <strong>Amount:</strong> {{ payment.amount }}
        </li>
        <li class="list-group-item">
          <strong>Status:</strong> {{ payment.status }}
        </li>
        <li class="list-group-item">
          <strong>Session:</strong> {{ payment.session }}
        </li>
        <li class="list-group-item">
          <strong>Date Paid:</strong> {{ payment.date_paid }}
        </li>
      </ul>
      <div v-if="breakdownItems && breakdownItems.length">
        <h6>Payment Breakdown</h6>
        <b-table
          :items="breakdownItems"
          :fields="breakdownFields"
          small
          bordered
        ></b-table>
      </div>
      <div v-else-if="breakdownItems">
        <h6>Payment Breakdown</h6>
        <ul class="list-group">
          <li class="list-group-item">
            <strong>Type:</strong> {{ breakdownItems.type }}<br />
            <strong>Amount:</strong> {{ breakdownItems.amount }}
          </li>
        </ul>
      </div>
      <div v-else class="text-muted">No breakdown available.</div>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requeryLoading: false,
      requeryMessage: "",
      requerySuccess: false,
    };
  },
  methods: {
    async requeryPayment() {
      const ref = this.payment?.rrr || this.payment?.gateway_ref;
      if (!this.payment || !ref) return;
      this.requeryLoading = true;
      this.requeryMessage = "";
      this.requerySuccess = false;
      try {
        let response;
        if (this.payment.gateway === "interswitch" && this.payment.gateway_ref) {
          response = await axios.post("/api/interswitch/requery", {
            txn_ref: this.payment.gateway_ref,
            type: "student",
          });
          if (response.data && response.data.msg === "success") {
            const respCode = response.data.data?.ResponseCode;
            this.requeryMessage = response.data.data?.ResponseDescription || "Status checked.";
            if (respCode === "00") {
              this.requerySuccess = true;
              this.payment.status = "SUCCESS";
            } else {
              this.requerySuccess = false;
              this.payment.status = "PENDING";
            }
          } else {
            this.requeryMessage = "Re-query failed.";
            this.requerySuccess = false;
          }
        } else {
          response = await axios.post("/api/checkRRRStatus_update_record", {
            rrr: this.payment.rrr,
          });
          if (response.data && response.data.success) {
            this.requeryMessage =
              response.data.message || "Status checked successfully.";
            this.requerySuccess = true;
            if (response.data.remita_status === "00") {
              this.payment.status = "SUCCESS";
            } else if (response.data.remita_status === "021") {
              this.payment.status = "PENDING";
            } else {
              this.payment.status = "FAILED";
            }
          } else {
            this.requeryMessage =
              (response.data && response.data.message) || "Re-query failed.";
            this.requerySuccess = false;
          }
        }
        this.$emit("update:payment", { ...this.payment });
      } catch (e) {
        this.requeryMessage = "Re-query failed. Please try again.";
        this.requerySuccess = false;
      } finally {
        this.requeryLoading = false;
      }
    },
  },
  props: {
    show: Boolean,
    payment: Object,
    modalId: {
      type: String,
      default: "payment-details-modal",
    },
    modalTitle: {
      type: String,
      default: "Payment Details",
    },
  },
  computed: {
    breakdownItems() {
      if (!this.payment) return null;
      if (Array.isArray(this.payment.payment_breakdown)) {
        return this.payment.payment_breakdown;
      }
      if (typeof this.payment.payment_breakdown === "object") {
        return this.payment.payment_breakdown;
      }
      return null;
    },
    breakdownFields() {
      return [
        { key: "type", label: "Type" },
        { key: "amount", label: "Amount" },
        { key: "installment", label: "Installment" },
      ];
    },
  },
};
</script>

<style scoped>
.list-group-item strong {
  min-width: 120px;
  display: inline-block;
}
</style>
